import React, { useState, useEffect, useRef } from "react";
import './CateryName.css';

/**
 * Mesure la largeur d'un texte avec une police donnée
 */
function measureTextWidth(text, font) {
    const canvas =
        measureTextWidth.canvas ||
        (measureTextWidth.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}

/**
 * Hook personnalisé qui ajuste la taille de police
 */
function useAutoFontSize(
    text,
    defaultFontSize = 16,
    minFontSize = 10,
    fontFamily = "sans-serif"
) {
    const containerRef = useRef(null);
    const [fontSize, setFontSize] = useState(defaultFontSize);

    useEffect(() => {
        const adjustFontSize = () => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.offsetWidth;
                let currentFontSize = defaultFontSize;
                let font = `${currentFontSize}px ${fontFamily}`;
                let textWidth = measureTextWidth(text, font);

                while (textWidth > containerWidth && currentFontSize > minFontSize) {
                    currentFontSize -= 1;
                    font = `${currentFontSize}px ${fontFamily}`;
                    textWidth = measureTextWidth(text, font);
                }
                setFontSize(currentFontSize);
            }
        };

        adjustFontSize();

        window.addEventListener("resize", adjustFontSize);
        return () => window.removeEventListener("resize", adjustFontSize);
    }, [text, defaultFontSize, minFontSize, fontFamily]);

    return { fontSize, containerRef };
}

/**
 * Composant CateryName moderne
 */
const CateryName = ({ items, catPRo = false, cateryNameStyle = false }) => {
    const defaultFontSize = 16;
    const minFontSize = 10;
    
    let cateryName = catPRo ? items.name[0] : items.categoryName;
    
    const { fontSize, containerRef } = useAutoFontSize(
        cateryName,
        defaultFontSize,
        minFontSize,
        "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
    );

    return (
        cateryNameStyle ? 
                cateryName
        :
      cateryName &&  <div
            // ref={containerRef}
            className="catery-name-header"
            style={{ fontSize: `${fontSize}px` }}
        >
            <span className="catery-name-text">{cateryName}</span>
        </div>
    );
};

export default CateryName;